import React, { useState, useEffect, useRef } from 'react';

const LazyImage = ({ src, alt, className, style, placeholder }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '200px', // Start loading 200px before entering viewport
        threshold: 0
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={imgRef} className={className} style={style}>
      {isInView ? (
        <img
          src={src}
          alt={alt}
          className={`w-full h-full object-cover transition-opacity duration-300 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          style={style}
          onLoad={() => setIsLoaded(true)}
        />
      ) : null}
      {/* Show placeholder until image is loaded */}
      {(!isInView || !isLoaded) && (
        <div className="absolute inset-0 flex items-center justify-center">
          {placeholder}
        </div>
      )}
    </div>
  );
};

export default LazyImage;